const state = {
	snippet_js: {
	},
	snippet_prescript: {
	},
	snippet_postscript: {
	},
	snippet_datasource: {
	}
}

const mutations = {
}

const actions = {
}

const getters = {
	snippet_js: (state) => {
		return state.snippet_js
	},
	snippet_prescript: (state) => {
		return state.snippet_prescript
	},
	snippet_postscript: (state) => {
		return state.snippet_postscript
	},
	snippet_datasource: (state) => {
		return state.snippet_datasource
	}
}

export default {
	state,
	mutations,
	actions,
	getters
}
